export default "__VITE_ASSET__ee442c46__"